import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../service/auth.service";
import { TranslocoService } from "@jsverse/transloco";
import { SidenavInterface } from "../models/sidenav.models";

@Component({
  selector: "app-pages",
  template: `
  <div id="auth-container" class=" !w-screen !h-[100dvh] overflow-scroll relative overflow-x-hidden custom-scroll" >
  <div *transloco="let t" class="bg-transparent  !w-screen flex flex-wrap z-[2] absolute">
 <app-menu></app-menu>
  <div class=" !w-screen min-h-[982px] mt-[80px] px-5 aspect43:px-[60px]">
    <router-outlet></router-outlet></div>
  </div> 
</div>`,
  styles: [],
  standalone: false,
})
export class AuthComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
    private translocoService: TranslocoService
  ) { }
  logged = false;
  currentBreadcrumb: any = null;
  userInfo = { username: "Gino Rapollo" };
  menuItems: SidenavInterface[] = [];
  isMenuOpen = window.innerWidth > 768;
  userData: any = {};

  ngOnInit(): void {
    // if (localStorage.getItem("token")) {
    //   this.getMe();
    // } else {
    //   localStorage.clear();
    //   window.location.replace("login");
    // }
  }

  changeMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  menuChanged(menuExpanded: boolean) {
    this.isMenuOpen = menuExpanded;
  }

  getMe() {
    this.translocoService.selectTranslateObject("routes").subscribe((route) => {
      this.menuItems = [];
      this.menuItems.push({
        text: route.employees.menu,
        route: route.employees.path,
        iconUrl: "../assets/employee.svg",
      });
      this.logged = true;
    });
  }
  getBreadCrumb() {
    let breadcrumb: any =
      this.router.routerState?.root?.children[0]?.children[0];

    if (breadcrumb) {
      if (
        breadcrumb.data?._value?.currentElement ||
        breadcrumb.data?._value?.currentElement == 0
      ) {
        this.currentBreadcrumb = breadcrumb.data?._value?.currentElement;
      } else {
        this.currentBreadcrumb = null;
      }
      return breadcrumb.data?._value?.breadcrumb;
    } else {
      return [];
    }
  }

  goTo(menuItem: any) {
    this.router.navigate([menuItem.route]);
    if (window.innerWidth <= 768) {
      this.isMenuOpen = false;
    }
  }
  userClick() {
    this.translocoService.selectTranslateObject("routes").subscribe((route) => {
      this.router.navigate([route.userProfile.path]);
      this.logged = true;
    });
    if (window.innerWidth <= 768) {
      this.isMenuOpen = false;
    }
  }
}
